var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-block"},[_c('h3',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.chartName))]),_c('span',[_vm._v(_vm._s(_vm.updated))])]),_c('div',{staticClass:"chart-box",attrs:{"id":"chart_f"}})])}
var staticRenderFns = []

export { render, staticRenderFns }